import { deliveryStatusActionTypes, type IDeliveryStatusAction } from './actions';
import { type IDeliveryStatusState } from '@/types/deliveryStatus';
import { getISODateInUTC } from '@/utils/dates';

/** @TODO decouple IDeliveryStatusState from the SDK response type. */
export const initialState: IDeliveryStatusState = {
  // @ts-expect-error
  order_id: null,
  // @ts-expect-error
  order_number: null,
  // @ts-expect-error
  delivery_service: null,
  // @ts-expect-error
  driver_name: null,
  // @ts-expect-error
  driver_number: null,
  // @ts-expect-error
  status: null,
  // @ts-expect-error
  estimated_pick_up_time: null,
  // @ts-expect-error
  estimated_drop_off_time: null,
  // @ts-expect-error
  pick_up_time: null,
  // @ts-expect-error
  drop_off_time: null,
  // @ts-expect-error
  cancelled_at_time: null,
  // @ts-expect-error
  cancelled_reason: null,
  // @ts-expect-error
  lat: null,
  // @ts-expect-error
  long: null,
  meta: {
    loading: false,
    error: null,
    params: null,
    // @ts-expect-error
    lastUpdatedAt: null,
  },
};

export const deliveryStatus = (
  state: IDeliveryStatusState = initialState,
  action: IDeliveryStatusAction,
): IDeliveryStatusState => {
  switch (action.type) {
    case deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER: {
      const partialState: Partial<IDeliveryStatusState> = {
        order_number: action.order_number,
        meta: {
          error: null,
          loading: true,
          params: null,
        },
      };

      return Object.assign({}, state, partialState);
    }
    case deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_SUCCESS: {
      const partialState: Partial<IDeliveryStatusState> = {
        meta: {
          error: null,
          loading: false,
          params: null,
          lastUpdatedAt: getISODateInUTC(),
        },
        ...action.data,
      };

      return Object.assign({}, state, partialState);
    }
    case deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_FAIL: {
      const partialState: Partial<IDeliveryStatusState> = {
        meta: {
          error: action.error,
          loading: false,
          params: null,
          lastUpdatedAt: getISODateInUTC(),
        },
      };

      return Object.assign({}, state, partialState);
    }
    case deliveryStatusActionTypes.CLEAR_DELIVERY_STATUS_STATE:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};
